export default "__VITE_ASSET__c91f9fb2__"